import React from 'react';

export const FREE_PLAN_CAP_NOTE =
  'Once you reach $3,000 in monthly sales, payments and form submissions pause until the limit resets next month or you upgrade.';

/**
 * "What changes on the Free plan" list. Domain and email domain bullets are
 * per-seller; the rest always apply. Always-lost paid features are summarized
 * in one non-exhaustive "premium features like …" bullet. The monthly sales
 * cap is rendered as a separate closing note (FREE_PLAN_CAP_NOTE), not a bullet.
 * Custom confirmation and custom email confirmation stay on Free and are not listed.
 */
export function getFreePlanChanges(seller) {
  const changes = [];

  changes.push('Checkout Page branding is added to your store and emails');

  if (seller?.customDomain && seller?.customDomainVerified) {
    changes.push('Your custom domain is detached (reverts to a checkoutpage.dev subdomain)');
  }
  if (seller?.customEmailDomain) {
    changes.push('Your custom email domain reverts to Checkout Page');
  }

  changes.push(
    'Team members beyond the account owner lose dashboard access. They get access back when you upgrade again',
  );
  changes.push(
    'Premium features like one-click upsells, cart abandonment recovery, and tracking pixels turn off',
  );

  return changes;
}

export default function FreePlanChanges({ seller, className = '', showIntro = true }) {
  const changes = getFreePlanChanges(seller);

  return (
    <div className={className}>
      {showIntro && (
        <p className="text-sm text-gray-600 dark:text-muted-foreground">Switching to Free means:</p>
      )}
      <ul
        className={`list-disc list-outside pl-4 text-sm text-gray-600 dark:text-muted-foreground space-y-1 ${showIntro ? 'mt-1' : ''}`}
      >
        {changes.map(change => (
          <li key={change}>{change}</li>
        ))}
      </ul>
      <p className="text-sm text-gray-600 dark:text-muted-foreground mt-2">{FREE_PLAN_CAP_NOTE}</p>
    </div>
  );
}
